import {ChassisHeightSelectOption} from  "./types"
 
export const MANUFACTURER_OPTIONS: ChassisHeightSelectOption[] = [
  { value: "1", labelKey: "MANUFACTURERS.DATA.MERCEDES" },
  { value: "2", labelKey: "MANUFACTURERS.DATA.MAN" },
];

export const MASTER_MODEL_OPTIONS: ChassisHeightSelectOption[] = [
  { value: "10", label: "ACTROS 25xxL 26T" },
  { value: "11", label: "FLL42 15T" },
];

export const SUSPENSION_TYPE_OPTIONS: ChassisHeightSelectOption[] = [
  { value: "AIR", labelKey: "CHASSIS_HEIGHT.DATA.SUSPENSION_TYPE.AIR" },
  { value: "LEAF", labelKey: "CHASSIS_HEIGHT.DATA.SUSPENSION_TYPE.LEAF" },
];
